import api from 'api';
import { NDA_STATUSES, NDA_COPIES_WITHOUT_NAME } from 'models/Nda';
import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getUserFullNameOrEmail, sortOptions } from 'utils';

const useGetSearchableFilterOptions = () => {
  const { t } = useTranslation();

  const ndaOptions = useMemo(
    () =>
      Object.values(NDA_STATUSES).map((value) => ({
        value,
        label: t(NDA_COPIES_WITHOUT_NAME[value]),
      })),
    [t],
  );

  const getBMUserOptions = useCallback(async (searchString: string) => {
    const { data } = await api.portfolio.admin.getAllBMUsers({
      $searchString: searchString,
    });

    const options = data.map(({ userId, name }) => ({
      value: userId,
      label: name,
    }));

    return sortOptions(options);
  }, []);

  const getAllUserOptions = useCallback(async (searchString: string) => {
    const {
      data: { items },
    } = await api.portfolio.admin.getAllUsers({
      $searchString: searchString,
      $limit: '20',
    });

    const options = items.map((user) => ({
      value: user._id,
      label: getUserFullNameOrEmail(user),
    }));

    return sortOptions(options);
  }, []);

  const getLeadsOptions = useCallback(async (searchString: string) => {
    const { data } = await api.portfolio.admin.getLeads({
      $searchString: searchString,
    });

    const options = data.map(({ buyerId, name }) => ({
      value: buyerId,
      label: name,
    }));

    return sortOptions(options);
  }, []);

  const getDealOptions = useCallback(async (searchString: string) => {
    const { data } = await api.portfolio.admin.getDealRooms({
      $searchString: searchString,
    });

    const options = data.map(({ dealRoomId, name }) => ({
      value: dealRoomId,
      label: name,
    }));

    return sortOptions(options);
  }, []);

  return {
    ndaOptions,
    getBMUserOptions,
    getAllUserOptions,
    getLeadsOptions,
    getDealOptions,
  };
};

export default useGetSearchableFilterOptions;
